import React, { useState, useEffect } from 'react'
import { AnnouncementViewModalMetaProps, Announcement } from '../data/types'
import { Button } from './ui/Button'
import { Modal } from './ui/Modal'

type Props = {
    meta: AnnouncementViewModalMetaProps
    isOpen: boolean
    onClose: () => void
    initialAnnouncement?: Announcement | null
}

export const AnnouncementViewModal = (props: Props) => {
    const { meta, isOpen, onClose, initialAnnouncement } = props

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title={initialAnnouncement?.title || "Message Details"}
            icon={initialAnnouncement?.priority ? (
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 dark:bg-primary-900">
                    <span className="text-primary-600 dark:text-primary-400 font-bold text-lg">!</span>
                </span>
            ) : undefined}
            maxWidth="2xl"
            footer={
                <div className="flex justify-end">
                    <Button
                        type="button"
                        onClick={onClose}
                        variant="outline"
                        color="neutral"
                    >
                        {meta.cancelButton}
                    </Button>
                </div>
            }
        >
            {initialAnnouncement ? (
                <div className="px-6 py-4 max-h-[70vh] overflow-y-auto space-y-6">
                    {/* Content */}
                    <p className="text-gray-800 dark:text-gray-300 whitespace-pre-wrap">
                        {initialAnnouncement.content || "No content provided."}
                    </p>

                    {/* Priority */}
                </div>
            ) : (
                <div className="px-6 py-4 text-gray-600 dark:text-gray-300">
                    No announcement data available.
                </div>
            )}
        </Modal>
    );

}
